
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Search.css';
import Autosuggest from 'react-autosuggest';



const getSuggestions = (value, items) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : items.filter(i => {

        let descriptionSplit = i.description ? i.description.toLowerCase().split(' ') : [];
        let descriptionMatch = i.description ? descriptionSplit.some(e => inputValue.split(' ').indexOf(e.slice(0, inputLength)) > -1) : false; // rather forgiving in searching each of the words and not requiring all to be present

        let nameSplit = i.name ? i.name.toLowerCase().split(' ') : [];
        let nameMatch = i.name ? nameSplit.some(e => inputValue.split(' ').indexOf(e.slice(0, inputLength)) > -1) : false; // rather forgiving in searching each of the words and not requiring all to be present

        return nameMatch || descriptionMatch;
    }
    );
}

const getSuggestionValue = suggestion => suggestion.name;

const renderSuggestion = suggestion => (
    <div>
        {suggestion.name + (suggestion.description ? " - " + suggestion.description : "")}
    </div>
);

class SearchInput extends Component {
    constructor(props) {
        super(props);

        // Autosuggest is a controlled component.
        // This means that you need to provide an input value
        // and an onChange handler that updates this value (see below).
        // Suggestions also need to be provided to the Autosuggest,
        // and they are initially empty because the Autosuggest is closed.




        this.state = {
            value: '',
            suggestions: [],
            SearchItems: []
        };

    }


    //add each of the props to the selectedItems Array
    setItemsArr(props) {
        let selectedItemsArr = [];
        if (props.searchable && props.searchable.length > 0) {
            props.searchable.forEach((prop) => {
                if (prop && prop.length > 0) {
                    prop.forEach(item => {
                        selectedItemsArr.push(item);
                    })
                }

            })
        }
        this.setState({ SearchItems: selectedItemsArr })
    }
    componentWillReceiveProps(nextProps) {

        this.setItemsArr(nextProps);
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
        //dispatch filter set for rooms page;
        this.props.searchOnChange(newValue);
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value, this.state.SearchItems)
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.props.searchOnChange(suggestionValue, suggestion.id);

    }

    render() {
        const { value, suggestions } = this.state;

        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder: 'Search',
            value,
            onChange: this.onChange
        };

        // Finally, render it!
        return (
            <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={inputProps}
            />
        );
    }
}
SearchInput.propTypes = {
    searchOnChange: PropTypes.func.isRequired
}
export default SearchInput;


// WEBPACK FOOTER //
// ./src/Components/Search/Search.js